<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	//Stores
		//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Alert, Button, Select } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	let id = real_id(device.id);

	let settings = $settingsStore;

	const selectOptions = ['1x', '2x', '3x', '4x', '5x'];
	let buttonFadeRate =
		selectOptions[
			selectOptions.indexOf(
				$settingsStore[`${get_gen_2_component_channel_structure(device)}`]
					?.button_fade_rate + 'x',
			)
		];
	let cacheRate = buttonFadeRate;

	let loading = false;

	const setFadeRate = async () => {
		if (cacheRate === buttonFadeRate) return;
		loading = true;
		const fadeRateToRequest = selectOptions.indexOf(buttonFadeRate) + 1;
		const params = {
			id: device.channel,
			config: {
				button_fade_rate: fadeRateToRequest,
			},
		};

		const res: SettingRequest = await gen2Request(
			device,
			`${get_gen_2_component_from_category(device)}.SetConfig`,
			params,
		);
		const response = onSettingsResponse(res, device);
		if (response) {
			settings[`${get_gen_2_component_channel_structure(device)}`].fade_rate = fadeRateToRequest;
			devices_settings.update_devices_settings(id, settings);
			cacheRate = buttonFadeRate;
		} else {
			buttonFadeRate = cacheRate;
		}
		loading = false;
	};
</script>

<Alert
	class="mb-s"
	heading={$format('alert_heading_button_fade_rate', {
		default:
			'Controls how quickly the output brightness changes while the button is held down for dimming.',
	})}
/>

<Select
	class="mb-s"
	icon={'fas fa-sun'}
	options={selectOptions}
	bind:value={buttonFadeRate}
	id="select-jxtz5hh"
	aria-label={$format('alert_heading_button_fade_rate', {
		default:
			'Controls how quickly the output brightness changes while the button is held down for dimming.',
	})}
/>
<Button {loading} size="m" width="full" on:click={setFadeRate}>
	{$format('button_save')}
</Button>
